import { Stack } from "@mantine/core";
import { PageHeader } from "components";
import PageContent from "components/layouts/PageContent";
import { FC } from "react";

const DEBT_RECEIPT_PAGE_TITLE = "Phiếu thu công nợ";

const DebtReceiptWebLayout: FC = () => {
  return (
    <Stack gap="sm">
      <PageHeader breadcrumbs={[{ title: DEBT_RECEIPT_PAGE_TITLE, href: "" }]} />
      <PageContent>
        <Stack gap="xs">
        </Stack>
      </PageContent>
    </Stack>
  );
};

export default DebtReceiptWebLayout;
